import { useStaticQuery, graphql } from "gatsby"

export const useSectionClientsData = () => {
  const data = useStaticQuery(graphql`
  query clientsQuery {
    contentfulSectionClients {
      logos {
        url
      }
    }
  }
  `)

  return data.contentfulSectionClients
}
